<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-31 16:49:13
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-24 16:14:42
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\treatment\components\RightContent\questionDialog.vue
-->
<template>
    <div style="width:500px;">
        <span class="detail-top-txt">问卷详情</span>
        <div class="title-view">
            <h1 class="question-title" :title="paramData.title">{{paramData.title}}</h1>
            <h2>{{paramData.examTypeName}}</h2>
            <h3>{{paramData.startRemark}}</h3>
        </div>
        <div style="display:flex">
          <div style="height:600px;width:619px" class="scroll-bar-view">
            <!-- <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;" > -->
                <div v-for="(item,index) in paramData.questionAndItemList" :key="index">
                    <h5 style="font-weight:700;margin-bottom:20px">{{item.bigTitle}}</h5>
                    <h1>
                      <el-checkbox v-if="showCheck" v-model="item.checked"></el-checkbox>
                      <span v-if="item.sort">{{item.beforeSort}}.</span>{{item.description}}
                      <img style="width:80px;vertical-align: middle" v-if="item.questionPropertyVO && item.questionPropertyVO.urlList && item.questionPropertyVO.urlList[0]" :src="`${ossBaseUrl}${item.questionPropertyVO.urlList[0]}`">
                    </h1>
                    <div v-if="item.displayType == 4" style="color:gray;font-weight:bold;margin-left:15px">
                        <div>答案：{{ item.firstName ? item.firstName : '' }} {{ item.secondName ? item.secondName : '' }} {{ item.thirdName ? item.thirdName : '' }} {{ item.fourthName ? item.fourthName : '' }}</div>
                    </div>
                    <div style="color:gray" v-if="item.displayType === 17">
                      <span>答案 ：
                        <span>{{item.questionItemList[0].answerContent}}</span>
                        <span v-if="item.questionPropertyVO.type === 2" style="display:inline-block;margin:0 10px">~</span>
                        <span v-if="item.questionPropertyVO.type === 2">{{item.questionItemList[1].answerContent}}</span>
                      </span>
                    </div>
                    <div v-for="(son,index) in item.questionItemList" :key="index" style="margin-bottom:30px;color:#1A7BFC;font-weight:bold;text-indent: 15px;">
                        <!-- <span style="color:gray" v-if="item.displayType != 1 && item.displayType != 2 && item.displayType != 8 && item.displayType != 9 && item.displayType != 4 && item.displayType != 14">答案 ：{{ son.answerContent? son.answerContent : son.label }}</span> -->
                        <!-- <span style="color:gray" v-if="item.displayType == 1 || item.displayType == 2">答案 ：{{ son.answerContent? son.answerContent : son.label }} <span v-if="son.value" style="display:inline-block;margin-left:20px">其他 ：{{son.value}}</span> </span> -->

                        <span style="color:gray" v-if="item.displayType != 17 && item.displayType != 8 && item.displayType != 9 && item.displayType != 4 && item.displayType != 14 && item.displayType != 19">
                          答案 ：{{ son.answerContent? son.answerContent : son.label }} <span v-if="son.needInput" style="display:inline-block;margin-left:20px">说明 ：{{son.value}}</span>
                          <img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`" @click="handleLooklargeImg(son.pictureUrl,item.displayType)">
                        </span>
                        <span style="color:gray" v-if="item.displayType === 19">
                          答案 ：{{ son.answerContent}}{{ son.questionItemPropertyVO.selectedUnit && son.questionItemPropertyVO.selectedUnit.name }}
                          <!-- <img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`"> -->
                        </span>
                        <div v-if="item.displayType == 8 || item.displayType == 9" style="color:gray">
                            <div>题目：{{ son.label }}<img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`" @click="handleLooklargeImg(son.pictureUrl,item.displayType)"></div>
                            <div>
                              答案：{{ son.answerContent }}
                              <!-- <img style="width:80px;vertical-align: middle" v-if="son.pictureUrl" :src="`${ossBaseUrl}${son.pictureUrl}`"> -->
                            </div>
                        </div>
                        <span style="color:gray" v-if="item.displayType == 14">
                          <div class="img-item">
                            <img v-if="son.label" :src="`${ossBaseUrl}${son.label}`" style="height:90px">
                            <div>
                              <el-button size="small" style="margin-right:20px;" type="primary" @click="handleSyncImg(son.label,1,son.answerContent)">图片同步对照录入</el-button>
                              <el-button size="small" style="border: 1px solid #1A7BFC;color:#1A7BFC" @click="handleLooklargeImg(son.label,item.displayType,son)">查看大图</el-button>
                            </div>
                          </div>
                          
                        </span>
                    </div>
                    <p v-if="item.displayType == 14" class="img-tips">* 上传图片支持PNG / JPG 格式，图片不能大于10M，最多可上传9张</p>
                </div>
                <div style="margin:10px 0;text-align:center;color: red;">{{ paramData.endRemark }}</div>
            <!-- </el-scrollbar> -->

            <!-- 睡眠测评问卷分值显示模块 -->
            <div v-if="this.payloadData && this.payloadData.extension == 19 && JSON.parse(this.payloadData.data).patientSleepScoreId" class="sleep-test-result">
              <div class="sleep-test-score"><span>{{sleepScore}}</span><span>分</span></div>
              <p class="sleep-test-remark">{{sleepRemark}}</p>
              <!-- 雷达图部分 -->
              <div class="sleep-test-pic">
                <canvas id="canvasDom" class="sleep-charts"></canvas>
              </div>
              <!-- 睡眠评价部分 -->
              <div class="sleep-test-appraise">
                <span>睡眠评分</span>
                <p>
                  {{sleepAppraise}}
                </p>
              </div>
            </div>

            <div v-if="!imLook">
              <div v-if="showCheck && (feedBackItem.examTagId === 1 || feedBackItem.examTagId === 10) && feedBackItem.status !== 3" style="text-align:center">
                <el-button size="small" style="margin-right:20px;" type="primary" @click="handleRepeatSend">推送患者，重新做答</el-button>
              </div>
              <div v-if="!showCheck && (feedBackItem.examTagId === 1 || feedBackItem.examTagId === 10) && feedBackItem.status !== 3" class="pass-btns" style="text-align:center">
                <el-button size="small" style="margin-right:20px;" type="primary" @click="handlePass">通过</el-button>
                <el-button size="small" style="border: 1px solid #1A7BFC;color:#1A7BFC" @click="handleNoPass">不通过</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <span v-if="!imLook" slot="footer">
              <div v-if="showCheck && (feedBackItem.examTagId === 1 || feedBackItem.examTagId === 10) && feedBackItem.status !== 3" style="text-align:center">
                <el-button size="small" style="margin-right:20px;" type="primary" @click="handleRepeatSend">推送患者，重新做答</el-button>
              </div>
              <div v-if="!showCheck && (feedBackItem.examTagId === 1 || feedBackItem.examTagId === 10) && feedBackItem.status !== 3" class="pass-btns" style="text-align:center">
                <el-button size="small" style="margin-right:20px;" type="primary" @click="handlePass">通过</el-button>
                <el-button size="small" style="border: 1px solid #1A7BFC;color:#1A7BFC" @click="handleNoPass">不通过</el-button>
              </div>
        </span> -->
        <!-- 查看大图 -->
        <el-dialog
          title="图片操作"
          :visible.sync="previewPictures"
          :close-on-click-modal="false"
          width="650px"
          center
        >
          <div class="viewer-pic">
            <div style="text-align:center;line-height:40px" v-if="!editPicStatus && previewPicturesUrl.indexOf('dsicm-h5') != -1">{{picName}}<i class="el-icon-edit" @click="editPicName"></i></div>
            <div style="display:flex" v-if="editPicStatus && previewPicturesUrl.indexOf('dsicm-h5') != -1"><el-input style="width:350px" v-if="editPicStatus" maxlength="20" v-model="picName"></el-input><i v-if="editPicStatus" class="el-icon-check" @click="savePicName"></i></div>
            <el-button v-if="previewPicturesUrl.indexOf('dsicm-h5') != -1" type="primary" @click="handleSyncImg(previewPicturesUrl)">
                对照录入</el-button>
          </div>      
          <div class="image-preview" :style="{backgroundImage: 'url(' + ossBaseUrl + previewPicturesUrl + ')', backgroundSize:'contain',backgroundPosition:'center',backgroundRepeat: 'no-repeat','transform': directRotate === 'left'?`rotate(${rightcount}deg)`:directRotate === 'right' ? `rotate(${rightcount}deg)`: ''}">
            <!-- <img :src="previewPicturesUrl" alt="" style="display:block;margin:0 auto"
            :style="{'transform': directRotate === 'left'?`rotate(${rightcount}deg)`:directRotate === 'right' ? `rotate(${rightcount}deg)`: '',
                    'height': rightcount !== 0 && (rightcount % 90 === 0 || rightcount % 90 === -0  || rightcount % 270 === -0 || rightcount % 270 === 0) ? '600px' : '600px'}"
            /> -->
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="preImage">上一张</el-button>
            <el-button @click="nextImage">下一张</el-button>
            <el-button @click="leftRotate">左旋转</el-button>
            <el-button @click="rightRotate">右旋转</el-button>
            <!-- <el-button v-if="previewPicturesUrl.indexOf('dsicm-h5') != -1" type="primary" @click="handleSyncImg(previewPicturesUrl)">
              对照录入</el-button> -->
          </span>
        </el-dialog>
    </div>
</template>
<script>

import uCharts from '@/utils/u-charts.js'
import {updateQuestionItem, getSleepScoreById} from "@/api/addQuestionnaire"
import {checkToFiles,selectListExam,pushUnQualifyExamPaper,passFeedbackSubmitPatient } from '../../api/crossApi'
var uChartsInstance = {}
export default {
    name:'previewDialog',
    // inject: ['activeHande'],
    props:{
        payloadData:{
          type:Object,
          default: () => {}
        },
        feedBackItem: {
          type:Object,
          default: () => {}
        },
        paramDataObj:{
            type:Object,
            default: () => {}
        },
        wholeCourseId:{
            type:String
        },
        imLook: {
          type:Boolean,
          default: true
        },
        refresh: {
          type:Boolean,
          default: false
        }
    },
    data(){
        return{
            sleepScore: '',
            sleepRemark: '',
            sleepAppraise: '',

            categoriesData: [],
            seriesData: [{
              name: "",
              data: []
            }],

            paramData: {},
            needId: '',
            displayTypeNum: null,
            previewPicturesUrl: '',
            editPicStatus: false,
            picName: '',
            previewPictures: false,
            // checked: true,
            showCheck: false,
            ossBaseUrl: process.env.VUE_APP_OSS_URL, //预览图片基础路径
            previewVisible:false,//弹窗开关
            // questionAnswers:[],//数据展示
            picArr: [],
            // defaultImgIndex: 0,
            showPicList: false,
            directRotate: '',
            rightcount: 0,
            updateNameList: []
        }
    },
    watch:{
        // paramData(newVal,oldval){
        //     this.showPicList = false
        //     this.picArr = []
        //     this.questionAnswers = newVal.questionAndItemList
        //     this.questionAnswers.forEach(ele => {
        //       if (ele.displayType == 14) {
        //         // let arr = ele.questionItemList.map(v => v.label)
        //         let arr = []
        //         ele.questionItemList.forEach(v => {
        //           if (v.label) {
        //             arr.push(v.label)
        //           }
        //         })
        //         this.picArr.push(...arr)
        //       }
        //       if (ele.displayType == 1 || ele.displayType == 2 || ele.displayType == 8 || ele.displayType == 9) {
        //         // let arr = ele.questionItemList.map(v => v.pictureUrl)
        //         let arr = []
        //         ele.questionItemList.forEach(v => {
        //           if (v.pictureUrl) {
        //             arr.push(v.pictureUrl)
        //           }
        //         })
        //         this.picArr.push(...arr)
        //       }
        //     })
        //     // 重置数据
        //     // this.questionAnswers = []
        //     // this.showCheck = false
        // }
    },
    mounted() {
      // this.picArr = []
      // this.paramData.questionAndItemList.forEach(ele => {
      //   if (ele.displayType == 14) {
      //     let arr = ele.questionItemList.map(v => v.label)
      //     this.picArr.push(...arr)
      //   }
      //   if (ele.displayType == 1 || ele.displayType == 2 || ele.displayType == 8 || ele.displayType == 9) {
      //     let arr = ele.questionItemList.map(v => v.pictureUrl)
      //     this.picArr.push(...arr)
      //   }
      // })
      this.getFreshData()
    },
    methods:{
      // 获取睡眠评测分值相关数据
      async getSleepScoreData() {
        let res = await getSleepScoreById({
          id: JSON.parse(this.payloadData.data).patientSleepScoreId
        })
        if (res.code == 0) {
          this.sleepScore = res.data.totalScore
          this.sleepRemark = res.data.label
          this.sleepAppraise = res.data.description
          this.categoriesData = res.data.xlist
          for(let i = 0;i<res.data.ylist.length;i++){
            let val = res.data.ylist[i];
            if(val==0) {continue;}
            res.data.ylist[i]=Math.abs(val);
          }
          this.seriesData[0].data = res.data.ylist
        }
      },

      showCharts(){
        const canvas = document.getElementById('canvasDom');
        const ctx = canvas.getContext("2d");
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
        uChartsInstance['canvasDom'] = new uCharts({
          // animation: true,
          // background: "none",
          categories: this.categoriesData,
          // color: ["#1890FF","#91CB74","#FAC858","#EE6666","#73C0DE","#3CA272","#FC8452","#9A60B4","#ea7ccc"],
          // color: ["#15E7B5"],
          // padding: [
          //   5,
          //   5,
          //   5,
          //   5
          // ],
          context: ctx,
          extra: {
            radar: {
              gridType: "radar",
              gridColor: "#ffffff",
              gridCount: 3,
              labelColor: "#fff",
              opacity: 0.2,
              border: false,
              borderWidth: 2,
              max: 5,
            },
            tooltip: {
              showBox: true,
              showArrow: true,
              showCategory: false,
              borderWidth: 0,
              borderRadius: 0,
              borderColor: "#000000",
              borderOpacity: 0.7,
              bgColor: "#000000",
              bgOpacity: 0.7,
              gridType: "solid",
              dashLength: 4,
              gridColor: "#CCCCCC",
              fontColor: "#FFFFFF",
              splitLine: true,
              horizentalLine: false,
              xAxisLabel: false,
              yAxisLabel: false,
              labelBgColor: "#FFFFFF",
              labelBgOpacity: 0.7,
              labelFontColor: "#666666"
            }
          },
          height: canvas.height,
          legend: {
            show: false,
            position: "right",
            float: "center",
            padding: 5,
            margin: 5,
            backgroundColor: "#15E7B5",
            borderColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            fontSize: 13,
            fontColor: "#666666",
            lineHeight: 25,
            hiddenColor: "#CECECE",
            itemGap: 10
          },
          // padding: [15,15,0,5],
          series: this.seriesData,
          // [
          //     {
          //       name: "",
          //       data: [1,1,0,3,1,2,0]
          //     }
          //   ],
          // type: "radar",

          
          type: "radar",
          // canvasId: "",
          // canvas2d: true,
          background: "none",
          animation: true,
          timing: "easeOut",
          duration: 1000,
          color: ["#15E7B5"],
          padding: [
            5,
            5,
            5,
            5
          ],
          rotate: false,
          errorReload: true,
          fontSize: 13,
          fontColor: "transparent",
          enableScroll: false,
          touchMoveLimit: 60,
          enableMarkLine: false,
          dataLabel: true,
          dataPointShape: true,
          dataPointShapeType: "solid",
          tapLegend: false,
          



          width: canvas.width,
        });
        // canvas.onclick = function(e) {
        //   uChartsInstance[id].touchLegend(getH5Offset(e));
        //   uChartsInstance[id].showToolTip(getH5Offset(e));
        // };
        // canvas.onmousemove=function(e) {
        //   uChartsInstance[id].showToolTip(getH5Offset(e));
        // };
      },
      // changeShowIm(data) {
      //   this.paramData = data
      //   this.showIm = false
      // },
      async getFreshData() {
        this.picArr = []
        this.showPicList = false
        let res = await selectListExam({
          answerSheetId:this.paramDataObj.id
        })
        if(res.code === 0){
          this.paramData = res.data
          res.data.questionAndItemList.forEach(ele => {
            if (ele.displayType == 14) {
              // let arr = ele.questionItemList.map(v => v.label)
              let arr = []
              ele.questionItemList.forEach(v => {
                if (v.label) {
                  arr.push(v.label)
                }
              })
              this.picArr.push(...arr)
              this.updateNameList = ele.questionItemList
            }
            if (ele.displayType == 1 || ele.displayType == 2 || ele.displayType == 8 || ele.displayType == 9) {
              // let arr = ele.questionItemList.map(v => v.pictureUrl)
              let arr = []
              ele.questionItemList.forEach(v => {
                if (v.pictureUrl) {
                  arr.push(v.pictureUrl)
                }
              })
              this.picArr.push(...arr)
            }
          })
          if (this.payloadData.extension == 19 && JSON.parse(this.payloadData.data).patientSleepScoreId) {
            await this.getSleepScoreData()
            this.$nextTick(() => {
              this.showCharts()
            })
          }
        }else{
          this.$message.error(res.message)
        }
      },
      editPicName() {
        this.editPicStatus = true
      },
      async savePicName() {
        if(!this.picName){
          this.$message.error('文件名不能为空');
          return false
        }
        // let needId = this.picListName.filter(item => item.label === this.picArr[this.$refs.carouselRef.activeIndex])[0].id
        let res = await updateQuestionItem({
          id: this.needId,
          answerContent: this.picName
        })
        if (res.code === 0) {
          this.editPicStatus = false
          this.getFreshData()
        }
      },
      leftRotate() {
        if (this.rightcount === 0) {
          this.rightcount = 360
        }
        this.rightcount = this.rightcount - 90
        this.directRotate = 'left'
      },
      rightRotate() {
        if (this.rightcount === 360) {
          this.rightcount = 0
        }
        this.rightcount = this.rightcount + 90
        this.directRotate = 'right'
      },
      // 上一张图片
      async preImage() {
        this.rightcount = 0
        let nowPicIndex = this.picArr.findIndex(item => item == 'dsicm-' + this.previewPicturesUrl.split('dsicm-')[1])
        if (nowPicIndex === 0) {
          this.$message.error('已经是第一张照片')
        } else {
          this.previewPicturesUrl = this.picArr[nowPicIndex - 1]
        }
        if (this.previewPicturesUrl.indexOf('dsicm-h5') != -1) {
          let filterObj = {}
          filterObj = this.updateNameList.filter(v => v.label === this.previewPicturesUrl)[0]
          if (filterObj && filterObj.answerContent) {
            this.picName = filterObj.answerContent
          } else {
            this.picName = filterObj.label.split('/')[1]
          }
        }
      },
      // 下一张图片
      async nextImage() {
        this.rightcount = 0
        let nowPicIndex = this.picArr.findIndex(item => item == 'dsicm-' + this.previewPicturesUrl.split('dsicm-')[1])
        if (nowPicIndex === this.picArr.length - 1) {
          this.$message.error('已经是最后一张照片')
        } else {
          this.previewPicturesUrl = this.picArr[nowPicIndex + 1]
        }
        if (this.previewPicturesUrl.indexOf('dsicm-h5') != -1) {
          let filterObj = {}
          filterObj = this.updateNameList.filter(v => v.label === this.previewPicturesUrl)[0]
          if (filterObj && filterObj.answerContent) {
            this.picName = filterObj.answerContent
          } else {
            this.picName = filterObj.label.split('/')[1]
          }
        }
      },

      // leftRotate() {
      //   this.rightcount = this.rightcount - 90
      //   this.directRotate = 'left'
      // },
      // rightRotate() {
      //   this.rightcount = this.rightcount + 90
      //   this.directRotate = 'right'
      // },
      // // 预览时的图片同步对照录入
      // handlePreviewSyncImg() {
      //   // this.handleSyncImg(this.picArr[this.$refs.carouselRef.activeIndex])
      // },
      // 图片同步对照录入
      async handleSyncImg(url,flag,answerContent) {
        let filePath
        filePath = url + '?x-oss-process=image/rotate,' + this.rightcount
        if (flag === 1) {
          if (answerContent) {
            this.picName = answerContent
          } else {
            this.picName = url.split('/')[1]
          }
        }
        if(!this.picName){
          this.$message.error('文件名不能为空');
          return false
        }
        let res = await checkToFiles({
          filePath: filePath,
          wholeCourseId: this.wholeCourseId,
          fileName: this.picName
        })
        if (res.code === 0) {
          // this.previewVisible = false
          this.$message.success('标记成功')
        } else {
          this.$message.error(res.message)
        }
      },
      // 重新推送
      async handleRepeatSend() {
        let valCheck = this.paramData.questionAndItemList.some(item => item.checked == true)
        if (!valCheck) {
          this.$message.error('请勾选要重新推送的题目')
          return
        }
        let sheetQuestionIds = []
        this.paramData.questionAndItemList.forEach(ele => {
          if (ele.checked) {
            sheetQuestionIds.push(ele.id)
          }
        })
        let res = await pushUnQualifyExamPaper({
          answerSheetId: this.feedBackItem.refId,
          groupCode: this.feedBackItem.imId,
          patientId: this.feedBackItem.patientId,
          questionnaireName: this.feedBackItem.conent,
          sheetQuestionIds: sheetQuestionIds,
          tagName: this.feedBackItem.tagName,
          // type: 1,
          wholeCourseId: this.feedBackItem.wholeCourseId
        })
        if (res.code === 0) {
          this.previewVisible = false
          if (this.refresh) {
            this.$parent.$parent.propsUserItemHandel(this.$store.state.patientInfo)
          }
          // 推送成功之后返回im
          this.$parent.backToIM()
        }
      },
      // 通过
      async handlePass() {
        let res = await passFeedbackSubmitPatient(this.feedBackItem.id)
        if (res.code === 0) {
          this.previewVisible = false
          if (this.refresh) {
            this.$parent.$parent.propsUserItemHandel(this.$store.state.patientInfo)
          }
          // 通过之后返回IM
          this.$parent.backToIM()
        }
      },
      // 不通过
      handleNoPass() {
        this.showCheck = true
        this.paramData.questionAndItemList.map(v => {
          this.$set(v,'checked',false)
          // v.checked = false
        })

      },
      handleLooklargeImg(imgUrl,displayType,son) {
        this.rightcount = 0
        this.displayTypeNum = displayType
        if (son && son.id) {
          this.needId = son.id
        }
        // this.showPicList = true
        this.previewPictures = true
        if (son && son.answerContent) {
          this.picName = son.answerContent
        } else {
          this.picName = imgUrl.split('/')[1]
        }
        this.previewPicturesUrl = imgUrl
        // // window.open(process.env.VUE_APP_OSS_URL + imgUrl)
        // this.defaultImgIndex = this.picArr.findIndex(item => {
        //   return item === imgUrl
        // })
        // setTimeout(() => {
        //   this.$refs.carouselRef.setActiveItem(this.defaultImgIndex)
        // },0)
      },
      /**
       * @description: 关闭弹窗后的回调
       * @param {*}
       * @return {*}
       */    
      closeModal(){
          
      },
      /**
       * @description: 弹窗开关
       * @param {*}
       * @return {*}
       */    
      showVisible(){
          this.previewVisible = !this.previewVisible;
      },
    }
}
</script>

<style lang="less" scoped>
.question-title {
  width:300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 auto;
}
img {
  margin-left: 20px;
}
.title-view{
    h1{
        font-size: 20px;
        margin-bottom: 10px;
        text-align: center;
    }
     h2{
        font-size: 14px;
        margin-bottom: 10px;
        text-align: center;
    }
     h3{
        font-size: 12px;
        color: red;
        text-align: center;
    }
}
.scroll-bar-view{
    h1{
        font-weight: 600;
        margin-bottom: 20px;
    }
    .el-radio-group{
        display: flex;
        flex-direction: column;
    .el-radio{
        margin-bottom: 25px;
        .row-col{
            color: #ee1414;
            font-size: 12px;
            margin-top: 10px;
        }
    }
  }
  .img-item {
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .img-tips {
    font-size: 14px;
    color: #999999;
    line-height: 16px;
    margin-bottom: 20px;
  }
  /deep/.el-checkbox {
    margin-right: 20px;
  }
}
.el-dialog__footer {
  .pass-btns .el-button {
    width: 110px;
    height: 32px;
  }
}
// .preview-block {
//   width: 676px;
//   background: #333333;
//   margin-left: 30px;
//   padding: 10px;
//   i {
//     display: inline-block;
//     padding: 8px;
//     border-radius: 50%;
//     background-color: #FFFFFF;
//     color: #000000;
//     margin-left: 20px;
//     font-weight: 700;
//   }
// }
// /deep/.el-dialog {
//   width: fit-content !important;
// }
/deep/.el-carousel {
  height: 100%;
}
/deep/.el-carousel__container {
  height: 100%;
}
/deep/.el-carousel__arrow i {
  font-size: 33px;
}
.detail-top-txt {
  font-size: 14px;
  font-weight: 600;
  color: #1A7BFC;
  line-height: 22px;
}
.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  width:600px;
  height: 600px;
}
.viewer-pic {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  i {
    display: inline-block;
    padding: 8px;
    border-radius: 50%;
    background-color: #1a7bfc;
    color: #FFFFFF;
    margin-left: 20px;
    font-weight: 700;
    height:30px;
    margin-top: 5px;
  }
}
.sleep-test-result {
  // width: 375px;
  // height: 779px;
  // height:600px;
  width:600px;
  background: linear-gradient(180deg, #708CD8 0%, #4851A6 100%);
  padding: 30px;
  .sleep-test-score {
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 15px;
    span:nth-child(1) {
      font-size: 42px;
    }
    span:nth-child(2) {
      font-size: 16px;
    }
  }
  .sleep-test-remark {
    font-size: 12px;
    color: #FFFFFF;
    line-height: 17px;
    text-align: center;
  }
  .sleep-test-pic {
    text-align: center;
    margin-top: 20px;
    .sleep-charts {
      width: 100%;
      height: 200px;
    }
  }
  .sleep-test-appraise {
    span {
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 28px;
    }
    p {
      font-size: 12px;
      color: #FFFFFF;
      line-height: 27px;
    }
  }
}
</style>